<template>
  <div>
    <div class="lifestyle-pricelist-address" v-if="!isModalLoading">
      <div class="lifestyle-pricelist-address__description">
        <span class="mini-font">ADDRESS</span>
        <div class="subhead detail">{{address}}</div>
      </div>
      <div v-if="imageUrl" class="lifestyle-pricelist-address__image">
        <img :src="imageUrl" alt />
      </div>
      <div v-if="traffic" class="lifestyle-pricelist-address__location-profile">
        <div class="lifestyle-pricelist-address__location-profile__title">
          <span class="mini-font">LOCATION PROFILE</span>
        </div>
        <div class="lifestyle-pricelist-address__location-profile__content">
          <span class="subhead">Traffic Per Month</span>
          <div ><span class="subhead strong">{{traffic}}</span></div>
        </div>
      </div>
      <div v-if="dataOPHours.length > 0" class="lifestyle-pricelist-address__operating-hour">
        <div class="lifestyle-pricelist-address__operating-hour__title">
          <span class="mini-font">OPERATING HOURS</span>
        </div>
        <div class="lifestyle-pricelist-address__operating-hour__content">
          <div
            class="lifestyle-pricelist-address__operating-hour__content--item"
            v-for="(operatinghour, index) in OperatingHours"
            :key="index"
          >
            <span class="days">{{operatinghour.day}}</span>
            <span class="times"
              :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']"
            >{{operatinghour.time}}</span>
          </div>
        </div>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";

export default {
  name: "adx-lifestyle-placement-address",
  components: {
    "a-loading": ALoadingPrimary
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      bottomPrice: null,
      quantity: null,
      minQuantity: null,
      address: null,
      minPeriod: null,
      minPeriodPlan: null,
      imageUrl: null,
      traffic: null,
      placeHolder: "/img/notfound/img-placeholder_square.jpg",
      days: {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday"
      },
      OperatingHours: [
        {
          day: "Sunday",
          isOpen: false,
          time: "Unavailable"
        },
        {
          day: "Monday",
          isOpen: false,
          time: "Unavailable"
        },
        {
          day: "Tuesday",
          isOpen: false,
          time: "Unavailable"
        },
        {
          day: "Wednesday",
          isOpen: false,
          time: "Unavailable"
        },
        {
          day: "Thursday",
          isOpen: false,
          time: "Unavailable"
        },
        {
          day: "Friday",
          isOpen: false,
          time: "Unavailable"
        },
        {
          day: "Saturday",
          isOpen: false,
          time: "Unavailable"
        }
      ],
      dataOPHours: []
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.lifestylePricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.address = data.location.location_detail.address;
        this.traffic = data.location.traffic
        if (data.location.operating_hours) {
          this.dataOPHours = data.location.operating_hours;
          for (let day of data.location.operating_hours) {
            this.OperatingHours[day.day_of_week].isOpen = true;
            this.OperatingHours[day.day_of_week].time = this.timeDisplay(day);
          }
        }

        if (data.location.location_map) {
          this.imageUrl = data.location.location_map;
        }
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }
      return `${value} ${label}`;
    },
    timeFormatter(value) {
      let valueString = value.toString();
      if (valueString.length < 2) return "0" + valueString;
      return value;
    },
    timeDisplay(time) {
      return `${this.timeFormatter(time.start)} - ${this.timeFormatter(
        time.end
      )} WIB`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
